<div class="step-ejendomsfaktorer">
  <div class="step-content">
    @for (formGroup of formArray.groups(); track formGroup) {
      <ejendomsfaktor [formGroup]="formGroup" [ejendomsfaktorDefinitioner]="ejendomsfaktorDefinitioner"></ejendomsfaktor>
    }
  </div>
</div>
